import { cn } from "@pulsex/utils";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import Link from "next/link";
import { Widget } from "@pulsex/types";

export interface ISectionTitleProps {
  title?: string;
  className?: string;
  more?: string;
  widget?: Widget
}

export default function SectionTitle({
  title,
  className,
  more,
  widget,
}: ISectionTitleProps) {
  if (!title) return "";

  if (!more || more === "#")
    return (
      <h3
        className={cn(
          "text-[2.5rem] xl:text-3xl font-bold transition-all flex items-center gap-3 mb-5 dark:text-white",
          "lg:text-xl lg:font-bold lg:mb-3",
          className
        )}
      >
        <span>{title}</span>
      </h3>
    );

  // in 'Read More from this writer' widget inside article details, we want the title to redirect the user to the author's page
  if (widget?.moreLink === "{author_details}") {
    if (widget?.mainPost?.author) more = `/authors/${widget.mainPost.author.id}`
    else more = "/articles"
  }

  const Comp = more === "fake" ? "div" : Link;

  return (
    <h3>
      <Comp
        href={more || "#"}
        className={cn(
          "text-[2.5rem] xl:text-3xl font-bold transition-all flex items-center gap-3 mb-5 dark:text-white cursor-pointer hover:text-primary",
          "lg:text-xl lg:font-bold lg:mb-3",
          className
        )}
      >
        <span>{title}</span>
        <FontAwesomeIcon icon={faAngleRight} className="w-[10px] mt-2" />
      </Comp>
    </h3>
  );
}
